import { render, staticRenderFns } from "./RegisterThankyou.vue?vue&type=template&id=09a8df3d&scoped=true"
import script from "./RegisterThankyou.vue?vue&type=script&lang=js"
export * from "./RegisterThankyou.vue?vue&type=script&lang=js"
import style0 from "./RegisterThankyou.vue?vue&type=style&index=0&id=09a8df3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a8df3d",
  null
  
)

export default component.exports